var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step3" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("label", { staticClass: "header" }, [
          _vm._v("Please verify the information below is correct."),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "detail" }, [
          _vm._v("Appointment Location: "),
          _c("strong", [_vm._v(_vm._s(_vm.displayClinicAddress))]),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "detail" }, [
          _vm._v("Appointment Type: "),
          _c("strong", [_vm._v(_vm._s(_vm.displayAppointmentType))]),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "detail" }, [
          _vm._v("Appointment Date: "),
          _c("strong", [_vm._v(_vm._s(_vm.displayAppointmentDate))]),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "detail" }, [
          _vm._v("Appointment Time: "),
          _c("strong", [_vm._v(_vm._s(_vm.displayAppointmentTime))]),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "detail" }, [
          _vm._v("First Name: "),
          _c("strong", [_vm._v(_vm._s(_vm.patient.firstName))]),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "detail" }, [
          _vm._v("Last Name: "),
          _c("strong", [_vm._v(_vm._s(_vm.patient.lastName))]),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "detail" }, [
          _vm._v("Email Address: "),
          _c("strong", [_vm._v(_vm._s(_vm.patient.emailAddress))]),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "detail" }, [
          _vm._v("Phone Number: "),
          _c("strong", [_vm._v(_vm._s(_vm.patient.phoneNumber))]),
        ]),
        _vm._v(" "),
        _vm.patient.bringingFamiliarVoice
          ? [
              _c("span", { staticClass: "detail" }, [
                _vm._v("Familiar Voice: "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.patient.familiarVoiceFirstName) +
                      " " +
                      _vm._s(_vm.patient.familiarVoiceLastName)
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "detail" }, [
                _vm._v("Familiar Voice Relation: "),
                _c("strong", [_vm._v(_vm._s(_vm.patient.relation.name))]),
              ]),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c("fieldset", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.emailAddressVerify,
                expression: "form.emailAddressVerify",
              },
            ],
            staticClass: "emailAddressVerify",
            attrs: {
              placeholder: "Verify Email Address*",
              type: "email",
              tabindex: "3",
              required: "",
            },
            domProps: { value: _vm.form.emailAddressVerify },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "emailAddressVerify", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        !_vm.recaptchaSuccess
          ? _c("label", { staticClass: "recaptcha-error" }, [
              _vm._v('Please check the "I\'m not a robot" box to continue'),
            ])
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "footer-actions" }, [
      _c(
        "button",
        {
          staticClass: "btn-beltone xl",
          class: { disabled: _vm.submitting },
          on: {
            click: function ($event) {
              return _vm.prevStep()
            },
          },
        },
        [_vm._v("Back")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-beltone xl",
          class: { disabled: _vm.submitting },
          on: {
            click: function ($event) {
              return _vm.complete()
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.submitting,
                  expression: "submitting",
                },
              ],
              staticClass: "btn-spinner",
            },
            [_vm._m(0)]
          ),
          _vm._v(" "),
          _c("span", { class: { hidden: _vm.submitting } }, [
            _vm._v("Continue"),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "outer" }, [
      _c("div", { staticClass: "inner" }, [_c("span")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }